import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search } from "@air/next-icons";
import { ComboboxOptionText } from "@reach/combobox";
import { SearchSuggestionContainer } from "~/components/SearchBar/Suggestion/SearchSuggestionContainer";
export const TextSuggestion = (param)=>{
    let { value, onClick, index } = param;
    return /*#__PURE__*/ _jsxs(SearchSuggestionContainer, {
        className: "px-1 py-1.5",
        index: index,
        value: value,
        onClick: ()=>onClick(value),
        children: [
            /*#__PURE__*/ _jsx(Search, {
                className: "mr-3 h-5 w-4 text-grey-9 [&>path]:stroke-2"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "truncate",
                children: /*#__PURE__*/ _jsx(ComboboxOptionText, {})
            })
        ]
    });
};
